import getRouteConfig from "./getRouteConfig";

const homeRoute = getRouteConfig("Home", "/", "Home", []);

export default homeRoute;
